// @flow

import type {Action} from '../../types'
import type {PlaceState} from '../types'
import type {SetPlaceListPayload} from '../actions/setPlaceList'

export function setPlaceListReducer(state: PlaceState, action: Action<SetPlaceListPayload>): PlaceState {

  return {
    ...state,
    placeList: action.payload.placeList,
  }
}
